<template lang="pug">
v-card(class='auth-form')
  v-toolbar(dark flat color='primary')
    v-toolbar-title Регистрация
  v-card-text(class='pt-5')
    v-alert(
      :value='errors.has("common")'
      :dismissible='true'
      type='error'
      outline
      class='mb-5'
    )
      | {{ errors.first('common') }}
    v-form(@keyup.native.enter='tryRegister')
      v-text-field(
        :error='errors.has("phone")'
        :error-messages='errors.first("phone")'
        :prefix='focused || user.phone ? "+7" : ""'
        @focus="focused=true"
        @blur="focused=false"
        v-model='user.phone'
        prepend-icon='phone'
        name='phone'
        label='Телефон'
        type='text'
        mask=' (###) ###-##-##'
      )
      div(class='or') или
      v-text-field(
        :error='errors.has("email")'
        :error-messages='errors.first("email")'
        v-model='user.email'
        prepend-icon='email'
        name='email'
        label='Email'
        type='text'
      )
      v-text-field(
        :error-messages='errors.first("password")'
        :error='errors.has("password")'
        v-model="user.password"
        prepend-icon='lock'
        name='password'
        label='Пароль'
        type='password'
      )
      v-text-field(
        :error-messages='errors.first("c_password")'
        :error='errors.has("c_password")'
        v-model="user.c_password"
        prepend-icon='lock'
        name='c_password'
        label='Повторите пароль'
        type='password'
      )
  v-card-actions(class='card-actions')
    v-layout(column align-content-center)
      v-flex
        v-btn(
          @click='tryRegister'
          :loading='loading'
          color='primary'
          type='submit'
          block
          large
        ) Зарегистрироваться
      v-flex(class='register')
        router-link(:to='{ name: "Auth.Login" }') Аторизация
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions, mapMutations } from 'vuex'

export default {
  data: () => ({
    user: {
      phone: '',
      password: '',
      c_password: ''
    },
    loading: false,
    focused: false
  }),

  methods: {
    tryRegister() {
      this.loading = true

      this.logout()

      this.register(this.user)
        .then(() => {
          if (isEmpty(this.user.phone)) {
            this.$router.push({
              name: 'Auth.Notify',
              query: {
                mail: this.user.email
              }
            })
          } else {
            this.$router.push({
              name: 'Auth.ComfirmPhone',
              params: {
                id: this.user.phone
              }
            })
          }
        })
        .catch(this.$showServerErrors)
        .finally(() => {
          this.loading = false
        })
    },

    ...mapActions('auth', ['register']),
    ...mapMutations('auth', ['logout'])
  }
}
</script>

<style scoped>
.register {
  padding: 16px;
  text-align: center;
}
</style>
